module.exports = __webpack_public_path__ + "static/img/49.8d62c21c.png";